module.exports = __webpack_public_path__ + "img/download-order.6f91dbcf.svg";